<template>
  <div class="hello">
    <div class="text">
      <img src="../assets/images/hello/text.png" />
      <h2>周年纪念</h2>
    </div>
    <div class="click" @click="pastShow">
      <div class="photo">
        <img src="../assets/images/hello/photo.png" />
      </div>
      <div class="finger">
        <img src="../assets/images/hello/click.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['pageChange'],
  setup(props, { emit }) {
    const pastShow = () => {
      emit('pageChange', 'Past')
    }

    return {
      pastShow
    }
  }
}
</script>

<style scoped>
.hello {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  height: 100%;

  overflow: hidden;

  /* transition: all 0.5s ease-in-out; */
}

.hello .text {
  height: 50%;
  animation: text 1s ease;
}

.hello .text img {
  height: 100%;
  width: auto;
}

.hello h2 {
  font-family: mading;
  font-size: 60px;

  /* 动画 */
  overflow: hidden;
  /* 字显示在一行 */
  white-space: nowrap;
  /* animation: textH2An 1s linear forwards; */

  /* border-right: 2px solid transparent; */
  /* opacity: 0; */
  z-index: 10;
}

.hello .text,
.hello .click {
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;

  overflow: hidden;
}

.hello .click {
  height: 40%;
  animation: click 1s ease-in;
}

.hello .click img {
  height: 100%;
  width: auto;
}

.hello .text img,
.hello .click .photo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
}

.hello .click .finger {
  width: 45px;
  height: 45px;
  /* margin-top: 25px; */
  animation: finger 1s steps(1) 1s infinite;
  opacity: 0;
}

@keyframes text {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes textH2An {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
/* @keyframes caret {
  50% {
    border-right: 2px solid #150a29;
  }
} */

@keyframes click {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes finger {
  75% {
    opacity: 1;
  }
}

/* 音乐 */
@keyframes music {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 响应式 */
/* 超小屏幕(手机，<768px) */
@media screen and (max-width: 767px) {
  .hello .text img {
    height: 100%;
    width: 100%;
  }
  .hello h2 {
    font-size: 35px;
  }
}
</style>
